// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__X3kP_","buttons":"SendReceipts_buttons__1cgXV","email":"SendReceipts_email__1QfPp","bookApptTitle":"SendReceipts_bookApptTitle__247Cf"};